import { futureValueSIP } from "../../engine/calculations";
import { currencyAxis, yearsAxis } from "./reckonerAxes";

const config = {
  key: "rr-sip-fv",
  title: "SIP Future Value Ready Reckoner",
  category: "Ready Reckoners",
  description: "See the future value of a monthly SIP across a range of amounts and durations.",
  reckoner: true,
  rowAxis: currencyAxis("Monthly SIP", [5_000, 10_000, 15_000, 20_000, 25_000]),
  colAxis: yearsAxis("Years", [5, 10, 15, 20, 25, 30]),
  extraFields: [
    { key: "returnRate", label: "Expected annual return", type: "percent", default: 12, min: 1, max: 30, assumptionKey: "equityReturn" },
  ],
  computeCell(monthly, years, extra) {
    const annualRate = (Number(extra.returnRate) || 0) / 100;
    return futureValueSIP(monthly, annualRate, years * 12);
  },
};

export default config;
